import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import Picture from './Picture';
import Header from '../Type/Header';
import Eyebrow from '../Type/Eyebrow';
import Caption from '../Type/Caption';

import './Card.module.css';

class CompactCard extends PureComponent {
  render() {
    const {
      image,
      headline,
      classes,
      styles,
      children,
      imageCaption,
      eyebrowText,
      ctaText,
      authorImage
    } = this.props;
    return (
      <div styleName="card" className={classes} style={styles}>
        <div styleName="card-image">
          <div styleName="label-1">Label</div>
          <div styleName="overlay" />
          <div styleName="text-overlay">
            <p>Share</p>
          </div>
          {image ? (
            <Picture largeImage={image} width="100%" height={300} />
          ) : (
            ''
          )}
        </div>
        <div styleName="card-body">
          <Caption>{imageCaption}</Caption>
          <Eyebrow styleName="label-2">{eyebrowText}</Eyebrow>
          <Header level={3} displayAs={4}>
            {headline}
          </Header>
          <div styleName="content">{children}</div>
          <div styleName="author">
            {authorImage ? (
              <Picture
                largeImage={authorImage}
                width={60}
                height={300}
                styles={{
                  border: '1px solid #d6d6da',
                  borderRadius: '60px',
                  marginRight: '20px'
                }}
              />
            ) : (
              ''
            )}
            <em>By: Nicolai Tesla</em>
          </div>
          <div styleName="tertiary-cta">{ctaText}</div>
        </div>
      </div>
    );
  }
}

CompactCard.propTypes = {
  /** The large image URL */
  image: PropTypes.string,
  /** Headline title */
  headline: PropTypes.string.isRequired,
  classes: PropTypes.any,
  styles: PropTypes.object,
  ctaText: PropTypes.string,
  eyebrowText: PropTypes.string,
  children: PropTypes.node,
  imageCaption: PropTypes.string,
  authorImage: PropTypes.string
};

export default DisplayComponent(CompactCard);
